import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class BusinesslogicListenerService {

  @Output() businessLogicListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.businessLogicListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        });
  }
}
